import { render } from "./Prediction.vue?vue&type=template&id=2616ec96&scoped=true"
import script from "./Prediction.vue?vue&type=script&lang=js"
export * from "./Prediction.vue?vue&type=script&lang=js"

import "./Prediction.vue?vue&type=style&index=0&id=2616ec96&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2616ec96"]])

export default __exports__